var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9334 5.56101V5.56093C13.9334 5.30338 13.8819 5.04842 13.782 4.81104C13.682 4.5737 13.5357 4.35872 13.3516 4.1787C13.3516 4.17867 13.3515 4.17864 13.3515 4.1786L10.3916 1.28404L10.3916 1.28401C10.0304 0.930844 9.54531 0.733071 9.04016 0.733008H9.04008H4.00008C3.48733 0.733008 2.99558 0.936698 2.63301 1.29927C2.27044 1.66184 2.06675 2.15359 2.06675 2.66634V13.333C2.06675 13.8458 2.27044 14.3375 2.63301 14.7001C2.99558 15.0627 3.48733 15.2663 4.00008 15.2663H12.0001C12.5128 15.2663 13.0046 15.0627 13.3672 14.7001C13.7297 14.3375 13.9334 13.8458 13.9334 13.333V5.56101Z",
    stroke: "#00529C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 1.33301V3.99967C9.3335 4.3533 9.47397 4.69244 9.72402 4.94248C9.97407 5.19253 10.3132 5.33301 10.6668 5.33301H13.3335",
    stroke: "#00529C",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.53cdee3a0fcaad96f7d27839d78bdc64.svg";
export { ForwardRef as ReactComponent };